module.exports = __webpack_public_path__ + "static/scale-model-of-california-welcome-center-in-santa-rosa-california-a0013eac2e3774d2dde10733f725e643.png";